export const blogData = [
  {
    id: 1,
    title: "What is Blockchain?",
    description: "A beginner-friendly guide to blockchain technology.",
    date: "March 10, 2026",
    author: "Anna K.",
    image: "https://images.unsplash.com/photo-1621761191319-c6fb62004040",
    content:
      "Blockchain is a distributed ledger that ensures transparency, immutability, and security. This article covers how blocks link together and why consensus matters.",
    sections: [
      {
        heading: "How it Works",
        body: "Blockchain operates as a distributed ledger where transactions are grouped into blocks and linked together in chronological order. Each block is secured using cryptographic hashing, making it nearly impossible to alter past data without changing every subsequent block. Before a transaction is added, it must be validated by a network of nodes through consensus mechanisms such as Proof of Work or Proof of Stake. Once verified, the block is added permanently to the chain, ensuring transparency and immutability.",
      },
      {
        heading: "Why It Matters",
        body: "Blockchain technology introduces a new level of trust and transparency in digital systems. By removing the need for centralized intermediaries, it reduces costs, minimizes fraud, and increases efficiency. Industries such as finance, supply chain, healthcare, and governance can benefit from secure, tamper-proof records and improved accountability. Ultimately, blockchain empowers users with greater control over their data and transactions while fostering a more decentralized digital economy.",
      },
    ],
    tags: ["Blockchain", "Beginner", "Crypto"],
  },
  {
    id: 2,
    title: "Future of Digital Currency",
    description: "How crypto is shaping the financial world.",
    date: "March 15, 2026",
    author: "Leo M.",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0",
    content:
      "Digital currency adoption is accelerating globally. We explore tokenization, central bank digital currencies, and what this means for everyday users.",
    sections: [
      {
        heading: "Adoption Trends",
        body: "Countries and institutions are experimenting with CBDCs...",
      },
      {
        heading: "Challenges Ahead",
        body: "Liquidity, regulation, and interoperability still need to be solved...",
      },
    ],
    tags: ["Digital Currency", "Finance", "CBDC"],
  },
  {
    id: 3,
    title: "Top 5 Crypto Trends",
    description: "Trends you should watch this year.",
    date: "March 20, 2026",
    author: "Tara N.",
    image: "https://images.unsplash.com/photo-1640340434855-6084b1f4901c",
    content:
      "From DeFi to NFTs and Layer 2 scaling, these trends are shaping the next chapter of the blockchain economy.",
    sections: [
      {
        heading: "DeFi 2.0",
        body: "New protocols are focusing on security and sustainable yield...",
      },
      {
        heading: "Layer 2",
        body: "Scaling solutions are making Ethereum cheaper and faster...",
      },
    ],
    tags: ["Trends", "DeFi", "Scaling"],
  },
  {
    id: 4,
    title: "What is Blockchain?",
    description: "A beginner-friendly guide to blockchain technology.",
    date: "March 10, 2026",
    author: "Anna K.",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0",
    content:
      "Blockchain is a distributed ledger that ensures transparency, immutability, and security. This article covers how blocks link together and why consensus matters.",
    sections: [
      {
        heading: "How it Works",
        body: "Each transaction is validated and stored in blocks...",
      },
      {
        heading: "Why It Matters",
        body: "Financial systems gain trust, auditability, and decentralization...",
      },
    ],
    tags: ["Blockchain", "Beginner", "Crypto"],
  },
];
